export class ToastError extends Error {
  constructor(message) {
    super(message); 
    this.name = "ToastError";
  }
}
